module.exports = __webpack_public_path__ + "static/media/burgular2.fcdf61ab.jpg";